import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { ConnectionDetails } from "../../types/connection.types";

/**
 * Connection Slice - Manages LiveKit connection state
 */
interface ConnectionState {
  connectionDetails: ConnectionDetails | null;
}

// Initial State
const initialState: ConnectionState = {
  connectionDetails: null
};

// Slice Definition
const connectionSlice = createSlice({
  name: "connection",
  initialState,
  reducers: {
    /**
     * Sets the complete connection details.
     * Used when joining a room or initializing the session.
     */
    setConnectionDetailsRedux(state, action: PayloadAction<ConnectionDetails>) {
      state.connectionDetails = action.payload;
    },

    /**
     * Updates connection details partially.
     * Useful for updating specific fields like `isHost` or `participantName` without overwriting the entire object.
     */
    updateConnectionDetailsRedux(state, action: PayloadAction<Partial<ConnectionDetails>>) {
      if (state.connectionDetails) {
        state.connectionDetails = {
          ...state.connectionDetails,
          ...action.payload
        };
      }
    },

    /**
     * Clears all connection details.
     * Used on disconnect or logout.
     */
    clearConnectionDetailsRedux(state) {
      state.connectionDetails = null;
    }
  }
});

export const { setConnectionDetailsRedux, updateConnectionDetailsRedux, clearConnectionDetailsRedux } =
  connectionSlice.actions;

export default connectionSlice.reducer;
